// extracted by mini-css-extract-plugin
export default {"fab":"FloatingButton_fab__Geq5l","camera":"FloatingButton_camera__HUFjs","file":"FloatingButton_file__oNwsc"};